import { render, staticRenderFns } from "./FormReActivar.vue?vue&type=template&id=1ff80e36&"
import script from "./FormReActivar.vue?vue&type=script&lang=js&"
export * from "./FormReActivar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports